export default __webpack_public_path__ + "static/illustration-alleviate-7d685836e4b38ac9039cc17b2f776ce5.png";